import { createSlice } from '@reduxjs/toolkit'

export const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    cart: null,
    open: null,
    upsells: [],
    hasGift: false,
  },
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload
    },
    setCartOpen: (state, action) => {
      state.open = action.payload
    },
    setUpsells: (state, action) => {
      state.upsells = action.payload
    },
    setGift: (state, action) => {
      state.hasGift = action.payload
    },
  },
})

export const { setCart, setCartOpen, setUpsells, setGift } = cartSlice.actions

export default cartSlice.reducer
